import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { METHODOLOGY_EXPLAINER_PAGE_BIODIVERSITY_INDICATORS } from '@/config/constants';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
  MethodologyLink,
} from './Explainer';

export const BiodiversityExplainer = () => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='biodiversity-explainer'>
        {t('shared.ncaDetail.details.labels.howDoWeMeasureThis')}
      </ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>
          {t('shared.ncaDetail.details.biodiversity.explainers.howDoMeasureThis.headline')}
        </ExplainerTitle>
        <Stack className='items-start pb-6'>
          <ExplainerBody>
            <ExplainerCopy
              title={t('shared.ncaDetail.details.biodiversity.explainers.howDoMeasureThis.title')}
              body={t('shared.ncaDetail.details.biodiversity.explainers.howDoMeasureThis.body')}
            />
            {/* TODO: MVP-5260 - Bring Confidence Interval back to charts  */}
            {/* <ExplainerCopy
              title={t('shared.ncaDetail.details.explainers.howDoMeasureThis.confidenceInterval.title')}
              body={t('shared.ncaDetail.details.explainers.howDoMeasureThis.confidenceInterval.body')}
            /> */}
          </ExplainerBody>
          <MethodologyLink to={METHODOLOGY_EXPLAINER_PAGE_BIODIVERSITY_INDICATORS} />
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
